__turbopack_context__.v({
  "tab": "Tabs-module__8dR2qa__tab",
});
